import React, { createContext, useContext, useEffect, useState } from 'react';
import axiosInstance from '../../services/AxiosInstance';

// ── Back-office permissions ──────────────────────────────────────────────────
// The admin console is staff-only by deployment; the real authorization gate is
// server-side (Module1's IsBackOfficeAdmin on the global endpoints — Phase 5).
// So the client treats every admin route as reachable and lets the API return
// 403 where appropriate. We still best-effort fetch is_superuser for future
// fine-grained gating, but never block the UI on it.

const PermissionsContext = createContext(null);

const ALLOW = () => true;

export const PermissionsProvider = ({ children }) => {
  const [loaded, setLoaded] = useState(false);
  const [superuser, setSuperuser] = useState(false);
  const [codenames, setCodenames] = useState(new Set());

  useEffect(() => {
    // Best-effort: a global "me/permissions" endpoint may not exist yet (Phase 5).
    // Any failure simply leaves superuser=false; the UI stays fully reachable.
    axiosInstance.get('/global/accounts/me/permissions/')
      .then(res => {
        setSuperuser(!!res.data?.is_superuser);
        setCodenames(new Set(res.data?.codenames || []));
      })
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  const value = {
    loaded, superuser, codenames,
    hasPerm: ALLOW, canView: ALLOW, canAdd: ALLOW, canChange: ALLOW, canDelete: ALLOW, canRoute: ALLOW,
  };

  return <PermissionsContext.Provider value={value}>{children}</PermissionsContext.Provider>;
};

export const usePermissions = () => {
  const ctx = useContext(PermissionsContext);
  return ctx || {
    loaded: true, superuser: false, codenames: new Set(),
    hasPerm: ALLOW, canView: ALLOW, canAdd: ALLOW, canChange: ALLOW, canDelete: ALLOW, canRoute: ALLOW,
  };
};
